module.exports = __webpack_public_path__ + "static/media/logo-zh.56a31f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideMenu/logos/logo-zh.png
// module id = 1045
// module chunks = 0